import * as moment from 'moment';

export class OverlapRange {
  public overlapsDate: string;
  public overlapsFromDate: string;
  public overlapsToDate: string;

  constructor(overlapsDate: string, overlapsFromDate?: string, overlapsToDate?: string) {
    this.overlapsDate = overlapsDate;
    this.overlapsFromDate = overlapsFromDate;
    this.overlapsToDate = overlapsToDate;
  }

  static DatesToRange(startDate: any, endDate: any) {
    return new OverlapRange(
      moment(startDate).format('DD MMMM YYYY') + ' to ' + moment(endDate).format('DD MMMM YYYY'),
      moment(startDate).format('MM/DD/YYYY'),
      moment(endDate).format('MM/DD/YYYY')
    );
  }
}